/**
 * Opciones de Sentry para frontend2 (Fase 1).
 * Sin DSN queda disabled: no altera el bootstrap ni el runtime.
 */

export interface SentryEnvironmentLike {
	production: boolean;
	sentryDsn?: string;
	sentryEnvironment?: string;
	sentryRelease?: string;
}

export interface SentryInitOptions {
	dsn: string;
	enabled: boolean;
	environment: string;
	release?: string;
	tracesSampleRate: number;
}

export function resolveSentryInitOptions(
	env: SentryEnvironmentLike
): SentryInitOptions {
	const dsn = (env.sentryDsn || '').trim();
	return {
		dsn,
		enabled: Boolean(dsn),
		environment:
			env.sentryEnvironment ||
			(env.production ? 'production' : 'development'),
		release: env.sentryRelease || undefined,
		tracesSampleRate: 0,
	};
}
